<style lang="scss" scoped>
  .ARElementFileSelector {
    margin-top: 2rem;

    .active {
      background-image: linear-gradient(74deg, #ff5000, #ed8a16);
    }

    .disabled {
      background-image: linear-gradient(74deg, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25));
    }

    .column {
      padding-top: 0;
      padding-bottom: 0;
      padding-right: 0;
    }

    &__title {
      height: 2rem;
      width: 147px;
      font-size: 20px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: 0.6px;
      text-align: left;
      margin-left: 51px;
      color: #202020;
      display: inline-block;

      @media only screen and (max-width: 1000px) and (min-width: 768px) {
        width: 53px;
      }
      @media only screen and (max-width: 768px) {
        width: 53px;
      }
    }
    &__subtitle {
      height: 2rem;
      font-size: 14px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: 0.6px;
      text-align: left;
      margin-left: 51px;
      color: #202020;
      display: inline-block;

      @media only screen and (max-width: 1000px) {
        width: 45px;
      }
    }
    &__subtext {
      width: 301px;
      height: 57px;
      opacity: 0.5;
      font-family: Open Sans;
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: 0.4px;
      text-align: left;
      margin-left: 51px;
      margin-top: 15px;
      margin-bottom: 19px;
      color: #000000;

      @media only screen and (max-width: 1000px) {
        width: 200px;
      }
    }

    &__select-button {
      padding-top: 6px;
      margin-right: 24px;
      cursor: pointer;
      margin-left: 10px;
      width: 104.2px;
      height: 29.2px;
      border-radius: 14.6px;
      font-size: 10.2px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: 0.3px;
      text-align: center;
      color: #ffffff;
      @media only screen and (max-width: 1000px) {
        margin-right: 0;
      }
      @media only screen and (max-width: 768px) {
      }
    }

    &__filename {
      margin-top: 5px;
      margin-left: 50px;
      margin-bottom: 5px;
      font-size: 14px;
      font-family: Open Sans;
      letter-spacing: 0.4px;
      color: #000000;
      @media only screen and (max-width: 1000px) {
        font-size: 10px;
      }
    }

    &__close {
      float: right;
      margin-right: 40px;
      margin-top: 10px;
      cursor: pointer;
    }

    &__separator {
      width: 100%;
      border: solid 1px #f0f0f0;
    }

    &__select-input {
      display: none;
    }
    &__closed-arrow {
      margin-right: 21px;
      margin-top: 1rem;
    }
    &__hide {
      display: none;
    }
  }
</style>

<template lang="pug">
  .ARElementFileSelector
    .columns.is-mobile(@click="toggleList")
      .column
        .ARElementFileSelector__title {{title}}
        span.ARElementFileSelector__subtitle {{subtitle}}
      .column
        label
          .ARElementFileSelector__select-button(:disabled="isComplete", :class="isComplete ? 'disabled' : 'active' ")
            span(v-if="!isComplete") {{buttonActiveTitle}}
            span(v-else) {{buttonDisabledTitle}}
          input.ARElementFileSelector__select-input(v-if="!isComplete", type="file", ref='fileUpload', accept=".glb" id="files" @change="onFileChange")
      .column
        img.ARElementInfo__closed-arrow(src="@/assets/img/arrow-closed.png")(v-show="!closed")
        img.ARElementInfo__closed-arrow(src="@/assets/img/arrow-opened.png")(v-show="closed")
    .columns(v-show="closed")
      .column
        .columns.is-mobile(v-if="isObjectAdded")
          .column.ARElementFileSelector__filename.is-two-thirds {{this.objectFile.name}}
          .column
            img.ARElementFileSelector__close(v-if="isObjectAdded")(src="@/assets/img/close.png", @click="onClick()")
        <!--.columns.is-mobile(v-if="isMaterialAdded")-->
          <!--.column.ARElementFileSelector__filename.is-two-thirds {{this.materialFile.name}}-->
          <!--.column-->
            <!--img.ARElementFileSelector__close(v-if="isMaterialAdded")(src="@/assets/img/close.png", @click="onClick(materialFile)")-->
        <!--.columns.is-mobile-->
          <!--.column.ARElementFileSelector__filename.is-two-thirds(v-if="isTextureAdded") {{this.textureFile.name}}-->
          .column
            img.ARElementFileSelector__close(v-if="isTextureAdded")(src="@/assets/img/close.png", @click="onClick(textureFile)")
        .columns.is-mobile(v-if="!isObjectAdded && !isMaterialAdded && !isTextureAdded", v-show="closed")
          .column: .ARElementFileSelector__subtext {{subtext}}
    .ARElementFileSelector__separator
</template>

<script>
  import { mapMutations, mapGetters, mapActions } from 'vuex';
  import loaders from '../../../utils/engine/loaders';

  export default {
    name: 'ARElementFileSelector',

    props: {
      title: String,
      subtitle: String,
      subtext: String,
      buttonActiveTitle: String,
      buttonDisabledTitle: String,
      multiple: false,
    },
    data() {
      return {
        file: null,
        isComplete: false,
        isPartialComplete: false,
        closed: false,
        isObjectAdded: false,
        isMaterialAdded: false,
        isTextureAdded: false,
        objectFile: null,
        materialFile: null,
        textureFile: null,
        type: {
          object: 'obj',
          material: 'mtl',
          texture: {
            jpg: 'jpg',
            png: 'png',
          },
        },
        Files: {
          objFile: null,
          mtlFile: null,
          textureFile: null,
        },
      };
    },
    computed: {
      ...mapGetters('Firebase', ['getARElementInEditIsVerified']),
      whenisVerifyStateChange() {
        return this.getARElementInEditIsVerified;
      },
    },
    watch: {
      whenisVerifyStateChange(newVal) {
        if (newVal) {
          // Lets upload the Marker.
          this.uploadFiles();
        }
      },
    },
    async mounted() {
      // When this component is mounted. We check the following
      //     if the ARElement has the objURL and textureURL and materialURL
      //       true -> then load the respective files to the 3D space
      //       false - dont do anythin.
      const elem = await this.getARElementInEdit();
      const objectRef = elem.ARElem.objectUrl;
      const textureRef = elem.ARElem.textureUrl;
      const materialRef = elem.ARElem.materialUrl;

      // load the object.
      // if object is there. Only then load material and texture.
      if (objectRef) {
        let loadedFile = await this.getFileURLByRef(objectRef);
        if (loadedFile) {
          this.objectFile = loadedFile;
          this.isPartialComplete = true;
          this.isObjectAdded = true;
          this.Files.objFile = loadedFile;
          this.loadFileContent(loadedFile);
          this.set3DObjIsCompleteState(true);
          this.setisObjectChanged(false);
        }

        if (textureRef) {
          loadedFile = await this.getFileURLByRef(textureRef);
          if (loadedFile) {
            this.textureFile = loadedFile;
            this.isTextureAdded = true;
            this.textureFile = loadedFile;
            this.Files.textureFile = loadedFile;
            this.loadFileContent(loadedFile);
          }
        }
        if (materialRef) {
          loadedFile = await this.getFileURLByRef(materialRef);
          if (loadedFile) {
            this.materialFile = loadedFile;
            this.isMaterialAdded = true;
            this.materialFile = loadedFile;
            this.Files.mtlFile = loadedFile;
            this.loadFileContent(loadedFile);
          }
        }
        // Check if the object is complete. so we can disable the button.
        if (this.isObjectAdded) {
          this.isComplete = true;
        } else {
          this.isComplete = false;
        }
      }
    },
    methods: {
      ...mapMutations('Firebase', ['setAREleminEdit3DObjectPCState', 'setisObjectChanged']),
      ...mapActions('Firebase', ['upload3DFilesByElement', 'getFileURLByRef']),
      ...mapGetters('Firebase', ['getARElementInEdit', 'getisObjectChanged']),
      async uploadFiles() {
        if (this.Files.objFile) {
          const elemInEdit = this.getARElementInEdit();
          this.upload3DFilesByElement({
            files: { ...this.Files },
            objectUpdated: this.getisObjectChanged(),
            element: { ...elemInEdit },
          });
        }
      },
      async set3DObjIsCompleteState(currentState) {
        this.setAREleminEdit3DObjectPCState(currentState);
      },
      async onFileChange(e) {
        this.setisObjectChanged(true);
        this.file = e.target.files[0];

        const extension = this.file.name.toLowerCase().split('.').pop();
        if (extension === 'glb' && !this.isObjectAdded) {
          this.isPartialComplete = true;
          this.isObjectAdded = true;
          this.objectFile = this.file;
          this.Files.objFile = this.file;
          this.isComplete = true;
          this.loadFileContent(this.file, true);
        }
        // Checking if the object is partially complete
        if (this.isObjectAdded) {
          // TODO: Do the removal of the state too upon deletion/removal
          this.set3DObjIsCompleteState(true);
        }
      },
      async loadFileContent(fileToLoad, newFile = false) {
        const fileType = fileToLoad.name.toLowerCase().split('.').pop();
        const load = loaders.getLoaderBasedOnFiletype(fileToLoad);
        const fileContent = await loaders.loadFileContent(fileToLoad);
        let file = await load(fileContent);
        if (fileType === 'glb' && !newFile) {
          // if the object is being loaded from Firebase this
          // func call will set the params to the saved params.
          // otherwise default will be loaded.
          file = await this.setObjectParameters(file);
        }
        const data = {
          file,
          type: fileType,
        };

        // Emit the data event with the data and
        // the onData callback will get fired in the component
        // configuration in ARElement.vue
        this.$emit('data', data);
      },

      // Object parameters are only set if the parameters are saved already in the Firebase.
      // Incase of a new element. default params will be passed to the 3D Object.
      async setObjectParameters(object) {
        const obj3D = object;
        const elem = await this.getARElementInEdit();
        if (elem.ARElem.scale) {
          const scale = JSON.parse(JSON.stringify(elem.ARElem.scale));
          obj3D.scene.scale.x = scale.x;
          obj3D.scene.scale.y = scale.y;
          obj3D.scene.scale.z = scale.z;
        }
        if (elem.ARElem.relativePos) {
          const position = JSON.parse(JSON.stringify(elem.ARElem.relativePos));
          obj3D.scene.position.x = position.x;
          obj3D.scene.position.y = position.y;
          obj3D.scene.position.z = position.z;
        }
        if (elem.ARElem.rot) {
          const rotation = JSON.parse(JSON.stringify(elem.ARElem.rot));
          obj3D.scene.rotation.x = rotation.x;
          obj3D.scene.rotation.y = rotation.y;
          obj3D.scene.rotation.z = rotation.z;
        }

        return obj3D;
      },
      onClick() {
        // Emit the remove event and
        // the onRemove callback will get fired in the component
        // configuration in ARElement.vue
        // const file = f;
        this.isObjectAdded = false;
        this.set3DObjIsCompleteState(false);
        this.$emit('remove');
        //
        // const fileExtension = file.name.split('.').pop();
        //
        // if (fileExtension === 'obj') {
        //   this.isObjectAdded = false;
        //   this.set3DObjIsCompleteState(false);
        //   this.$emit('remove', file);
        // } else if (fileExtension === 'mtl') {
        //   this.isMaterialAdded = false;
        //   this.$emit('remove', file);
        // } else if (fileExtension === 'png' ||
        // fileExtension === 'jpg' || fileExtension === 'jpeg') {
        //   this.isTextureAdded = false;
        //   this.$emit('remove', file);
        // }
        this.isComplete = false;
        // document.getElementById('files').value = null;
      },
      toggleList() {
        this.closed = !this.closed;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/ARElement/components/ARElementFileSelector.vue